const EVT = "respina:favorites-changed";
import { apiDelete, apiGet, apiPost } from "./http";
import { isAuthenticated } from "./auth";

let cache = [];

function emit() {
  window.dispatchEvent(new Event(EVT));
}

export function onFavoritesChanged(cb) {
  const handler = () => cb(getFavorites());
  window.addEventListener(EVT, handler);
  return () => window.removeEventListener(EVT, handler);
}

export function getFavorites() {
  return Array.isArray(cache) ? cache : [];
}

export function isFavorite(type, value) {
  const v = String(value || "").trim().toUpperCase();
  return getFavorites().some((x) => x?.type === type && x?.value === v);
}

export async function loadFavorites() {
  if (!isAuthenticated()) {
    cache = [];
    return cache;
  }
  const data = await apiGet("/api/favorites");
  cache = Array.isArray(data?.favorites) ? data.favorites : [];
  emit();
  return cache;
}

export function clearFavoritesCache() {
  cache = [];
  emit();
}

export async function toggleFavorite({ type, value, label }) {
  const v = String(value || "").trim().toUpperCase();
  const l = String(label || "").trim() || v;
  if (!type || !v) return;

  // optimistic update
  const items = [...getFavorites()];
  const idx = items.findIndex((x) => x?.type === type && x?.value === v);
  if (idx >= 0) items.splice(idx, 1);
  else items.unshift({ type, value: v, label: l, created_at: new Date().toISOString() });
  cache = items;
  emit();

  try {
    await apiPost("/api/favorites/toggle", { type, value: v, label: l });
  } catch (e) {
    // revert to server state if call fails
    await loadFavorites();
    throw e;
  }
}

export async function removeFavorite(type, value) {
  const v = String(value || "").trim().toUpperCase();
  cache = getFavorites().filter((x) => !(x?.type === type && x?.value === v));
  emit();
  try {
    await apiDelete(`/api/favorites?type=${encodeURIComponent(type)}&value=${encodeURIComponent(v)}`);
  } catch (e) {
    await loadFavorites();
    throw e;
  }
}
